var CustomerType;
(function (CustomerType) {
    CustomerType["Individual"] = "Individual";
    CustomerType["Company"] = "Company";
})(CustomerType || (CustomerType = {}));
export default CustomerType;
